import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import './css/SiteFooter.css';

const SiteFooter = ({ isGameActive, playerName, onPlayAsGuest, onPlayAsPlayer }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    const confirmNavigation = (e, destination, isExternal = false) => {
        if (!isGameActive) {
            // If it's the blog and we aren't using a router for it, use href
            if (isExternal) return;

            e.preventDefault();
            navigate(destination);
            return;
        }

        e.preventDefault();

        Swal.fire({
            title: t('alert.titles.sure', 'Are you sure?'),
            text: t('alert.quit_game.text', 'A game is in progress. Leaving now will end your current session!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33', // Red for quitting
            cancelButtonColor: '#3085d6', // Blue for staying
            confirmButtonText: t('alert.quit_game.confirm', 'Yes, Quit Game'),
            cancelButtonText: t('alert.quit_game.cancel', 'Cancel'),
            background: '#1a1a1a',
            color: '#fff'
        }).then((result) => {
            if (result.isConfirmed) {
                if (isExternal) {
                    window.location.href = destination;
                } else {
                    // Navigate internally
                    navigate(destination);
                    // Force a reload if going to Home to reset the Welcome state if necessary
                    if (destination === '/') window.location.reload();
                }
            }
        });
    };

    const handlePlayClick = (e) => {
        e.preventDefault(); // Prevent page reload
        if (playerName) {
            onPlayAsPlayer();
        } else {
            onPlayAsGuest();
        }
    };

    return (
        <footer className="drubble-main-footer">
            <div className="footer-container">
                {/* Branding Column */}
                <div className="footer-col col-left">
                    <img
                        src="https://drubble.uk/wp-content/themes/drubble-blog-theme/assets/images/drubble-logo.png"
                        alt="Drubble Logo"
                        className="footer-logo"
                    />
                    <p>Drubble is the ultimate daily word challenge. Expand your vocabulary, one tile at a time.</p>
                </div>

                {/* Quick Links Column */}
                <div className="footer-col col-middle">
                    <h4>Quick Links</h4>
                    <ul className="footer-list">
                        <li><a href="/" onClick={(e) => confirmNavigation(e, '/')}>Home</a></li>
                        <li><a href="https://play.drubble.uk" onClick={handlePlayClick}>Play Game</a></li>
                        <li><a href="https://drubble.uk" target={"_blank"} rel="noreferrer">Blog</a></li>
                        <li><a href="https://drubble.uk/privacy-policy" target={"_blank"} rel="noreferrer">Privacy Policy</a></li>
                        <li><a href="https://drubble.uk/terms-of-service" target={"_blank"} rel="noreferrer">Terms of Service</a></li>
                        <li><a href="mailto:support@drubble.uk" target={"_blank"} rel="noreferrer">Support</a></li>
                    </ul>
                </div>

                {/* Newsletter Column */}
                <div className="footer-col col-right">
                    <h4>Stay Updated</h4>
                    <p>Join our newsletter for news, updates and notifications of breaking changes.</p>
                    {/* Simplified Newsletter Button for React */}
                    <div className="footer-newsletter-placeholder">
                        <a href="https://drubble.uk/blog" className="footer-cta-button">
                            Subscribe via Blog
                        </a>
                    </div>
                </div>
            </div>

            <div className="footer-copyright">
                <p>© {currentYear} DP Digital Online Ltd. Registered in Wales. Reg No. 16897530</p>
            </div>
        </footer>
    );
};

export default SiteFooter;